export default __webpack_public_path__ + "static/media/household-floor-plan-3-1.e26f9e49.png";